import React, { useMemo } from 'react';
import CalendarView from './CalendarView'; 
import './PlannerView.css';
import { generateProjectedSchedule } from '../curriculumService';
import { calculateLocalStreak } from '../utils/masteryUtils';

const PlannerView = ({ 
    docket, 
    userGoals, 
    subjectMapDerived, 
    allItemsMap, 
    onToggleBreakDay, 
    userAccessLevel, 
    userData,
    onOpenConfig,
    seenHints,
    onDismissHint
}) => {
    const isLoading = !allItemsMap || allItemsMap.size === 0 || !userData;
    const isMixMode = userGoals?.mix_mode === true;

    const forecastMap = useMemo(() => {
        if (isLoading) return new Map();
        return generateProjectedSchedule({ userData, allItemsMap });
    }, [userData, allItemsMap, isLoading]);

    const displayStreak = useMemo(() => calculateLocalStreak(docket), [docket]);

    if (isLoading) return (
        <div className="planner-loading-state">
            <div className="loading-spinner"></div>
            <p>Projecting your path...</p>
        </div>
    );

    return (
        <div className="planner-view-container theme-aware">
            <header className="planner-header-refined">
                <div className="planner-title-group">
                    <h1>Planner</h1>

                    <div className="planner-streak-pill">
                        <span className="material-symbols-outlined fire-icon">local_fire_department</span>
                        <strong>{displayStreak} DAY STREAK</strong>
                    </div>


                    {userGoals?.target_mastery_date && (
                        <div className="planner-target-date">
                            <span className="material-symbols-outlined">track_changes</span>
                            <strong>{new Date(userGoals.target_mastery_date + 'T00:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</strong>
                        </div>
                    )}
                </div>
                
                <div className="planner-toolbar">
                    <button onClick={onOpenConfig} className="btn-utility strategy-btn">
                        <span className="material-symbols-outlined">tune</span>
                        <span>Strategy & Priority</span>
                    </button>
                    <div className="planner-header-legend">
                        <div className="legend-item">
                            <span className="swatch break-swatch"></span>
                            <span>Break</span>
                        </div>
                        <div className="legend-item">
                            <span>Click days to toggle breaks</span>
                        </div>
                    </div>
                </div>
            </header>

            <div className="planner-content-area">
                <CalendarView 
                    docket={docket} 
                    onToggleBreakDay={onToggleBreakDay} 
                    userGoals={userGoals} 
                    allItemsMap={allItemsMap} 
                    userAccessLevel={userAccessLevel} 
                    forecastMap={forecastMap}
                    subjectMapDerived={subjectMapDerived}
                    isMixMode={isMixMode}
                    seenHints={seenHints}
                    onDismissHint={onDismissHint}
                />
            </div>
        </div>
    );
};

export default PlannerView;